/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!************************************!*\
  !*** ./src/assets/js/customers.js ***!
  \************************************/
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var SectionContainer = function () {
  function SectionContainer() {
    _classCallCheck(this, SectionContainer);
    this.constructors = [];
    this.instances = [];
    this._attachListeners();
  }
  _createClass(SectionContainer, [{
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
      document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
      document.addEventListener('shopify:section:select', this._onSelect.bind(this));
      document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
      document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
      document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
    }
  }, {
    key: "register",
    value: function register(type, constructor) {
      var _this = this;
      this.constructors[type] = constructor;
      document.querySelectorAll("[data-section-type=".concat(type, "]")).forEach(function (container) {
        _this._createInstance(container, constructor);
      });
    }
  }, {
    key: "_findInstance",
    value: function _findInstance(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    }
  }, {
    key: "_removeInstance",
    value: function _removeInstance(array, key, value) {
      var i = array.length;
      while (i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
      return array;
    }
  }, {
    key: "_onSectionLoad",
    value: function _onSectionLoad(event) {
      var container = event.target.querySelector('[data-section-id]');
      if (container) {
        this._createInstance(container);
      }
    }
  }, {
    key: "_onSectionUnload",
    value: function _onSectionUnload(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
      if (!instance) {
        return;
      }
      if (typeof instance.onUnload === 'function') {
        instance.onUnload(event);
      }
      this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
    }
  }, {
    key: "_onSelect",
    value: function _onSelect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(event);
      }
    }
  }, {
    key: "_onDeselect",
    value: function _onDeselect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(event);
      }
    }
  }, {
    key: "_onReorder",
    value: function _onReorder(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
      if (instance && typeof instance.onReorder === 'function') {
        instance.onReorder(event);
      }
    }
  }, {
    key: "_onBlockSelect",
    value: function _onBlockSelect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(event);
      }
    }
  }, {
    key: "_onBlockDeselect",
    value: function _onBlockDeselect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(event);
      }
    }
  }, {
    key: "_createInstance",
    value: function _createInstance(container, constructor) {
      var id = container.getAttribute('data-section-id'),
        type = container.getAttribute('data-section-type');
      constructor = constructor || this.constructors[type];
      if (typeof constructor === 'undefined') {
        return;
      }
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (exception) {
        console.error('Logged exception (this may happen if you have tried to edit the code without properly adjusting the JavaScript): ' + exception.message);
      }
    }
  }]);
  return SectionContainer;
}();
var AccountSection = /*#__PURE__*/function () {
  function AccountSection(element) {
    _classCallCheck(this, AccountSection);
    this.element = element;
    this._setupAddressForm();
    this._attachListeners();
  }
  _createClass(AccountSection, [{
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      this.element.querySelectorAll('[data-target="AddressForm"]').forEach(function (el) {
        return el.addEventListener('click', _this2._toggleNewAddressForm.bind(_this2));
      });
      this.element.querySelectorAll('.btn-edit-address').forEach(function (el) {
        return el.addEventListener('click', _this2._toggleEditAddressForm.bind(_this2));
      });
    }
  }, {
    key: "_toggleNewAddressForm",
    value: function _toggleNewAddressForm(event) {
      this.element.querySelector('#AddressForm').classList.toggle('hidden');
      this.element.querySelector('#AddressNewButton').classList.toggle('hidden');
      this.element.querySelectorAll('.edit-form').forEach(function (el) {
        return el.classList.add('hidden');
      });
      this.element.querySelector('#new_address_form').classList.remove('hidden');
      event.preventDefault();
    }
  }, {
    key: "_toggleEditAddressForm",
    value: function _toggleEditAddressForm(event) {
      console.log("edit");
      var target = event.target.getAttribute('data-target');
      var form = null;
      try {
        form = document.querySelector('#'.concat(target));
        console.log(form);
      } catch (error) {}
      if (form) {
        console.log(form);
        var addressForm = this.element.querySelector('#AddressForm');
        addressForm.classList.remove('hidden');
        addressForm.scrollIntoView();
        this.element.querySelector('#AddressNewButton').classList.add('hidden');
        this.element.querySelectorAll('.edit-form').forEach(function (el) {
          return el.classList.add('hidden');
        });
        this.element.querySelector('#new_address_form').classList.add('hidden');
        addressForm.appendChild(form);
        form.classList.remove('hidden');
        if (Shopify && Shopify.CountryProvinceSelector) {
          var addressId = form.querySelector('.address-id').getAttribute('data-address-id');
          new Shopify.CountryProvinceSelector('AddressCountryNew'.concat(addressId), 'AddressProvinceNew'.concat(addressId), {
            hideElement: 'AddressProvinceNewWrapper'.concat(addressId)
          });
        }
      }
      event.preventDefault();
    }
  }, {
    key: "_setupAddressForm",
    value: function _setupAddressForm(event) {
      var _this3 = this;
      if (Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceNewWrapper'
        });
      }
      this.element.querySelector('#AddressCountryNew').addEventListener('change', function () {
        _this3.element.querySelector('#AddressProvinceNew').dispatchEvent(new Event('blur'));
      });
      this.element.querySelectorAll('.address-delete-form').forEach(function (deleteForm) {
        deleteForm.addEventListener('submit', function (event) {
          var confirmMessage = event.target.getAttribute('data-confirm-message');
          if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            event.preventDefault();
          }
        });
      });
    }
  }]);
  return AccountSection;
}();
var LoginSection = function () {
  function LoginSection(element, options) {
    _classCallCheck(this, LoginSection);
    this.element = element;
    this.tabLogin = this.element.querySelector('a.tab-login');
    this.tabRegister = this.element.querySelector('a.tab-register');
    this.tabReset = this.element.querySelector('a.tab-reset');
    this.formLogin = this.element.querySelector('form.form-login');
    this.formReset = this.element.querySelector('form.form-reset');
    this._attachListeners();
  }
  _createClass(LoginSection, [{
    key: '_attachListeners',
    value: function _attachListeners() {
      this.element.querySelector('.forgt-password').addEventListener('click', this._recover_password.bind(this));
      this.formReset.querySelector('.retun-text .sign-in').addEventListener('click', this._login.bind(this));
    }
  }, {
    key: '_recover_password',
    value: function _recover_password(event) {
      this.tabLogin.classList.add('hidden');
      this.tabRegister.classList.add('hidden');
      this.tabReset.classList.remove('hidden');
      this.formLogin.classList.add('hidden');
      this.formReset.classList.remove('hidden');
      event.preventDefault();
    }
  }, {
    key: '_login',
    value: function _login(event) {
      this.tabLogin.classList.remove('hidden');
      this.tabRegister.classList.remove('hidden');
      this.tabReset.classList.add('hidden');
      this.formLogin.classList.remove('hidden');
      this.formReset.classList.add('hidden');
      event.preventDefault();
    }
  }]);
  return LoginSection;
}();
function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}
(function () {
  var bootTheme = function bootTheme() {
    // Some polyfills not provided yet by polyfills.io
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }
    var sections = new SectionContainer();
    sections.register('account', AccountSection);
    sections.register('login', LoginSection);
  };
  docReady(function () {
    if ('fetch' in window && 'assign' in Object) {
      bootTheme();
    } else {
      var scriptEl = document.createElement('script');
      scriptEl.src = '//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList';
      scriptEl.async = false;
      scriptEl.onload = function () {
        bootTheme();
      };
      document.head.appendChild(scriptEl);
    }
  });
})();
/******/ })()
;